import { ThematicCategorySlug } from "../models/category.model";

// Pillar slugs (from database)
export type PillarSlug = 'body' | 'mind' | 'relations' | 'posture';

export const PILLAR_TRANSLATIONS: Record<PillarSlug, string> = {
  body: 'Le corps',
  mind: 'Le mental',
  relations: 'Les relations',
  posture: 'Posture et philosophie de vie',
};

const strongPillarColors: Record<string, string> = {
  body: '#7A5EA8',
  mind: '#C47A45',
  relations: '#2F8F80',
  posture: '#6E6872',
  individual: '#C47A45',
  environment: '#2F8F80',
  event: '#7A5EA8',
};

const lightPillarColors: Record<string, string> = {
  body: '#E4D4F5',
  mind: '#F6C9A0',
  relations: '#9EDFCF',
  posture: '#D5D0D8',
  individual: '#F6C9A0',
  environment: '#9EDFCF',
  event: '#E4D4F5',
};

const mediumPillarColors: Record<string, string> = {
  body: '#C9B0E4',
  mind: '#E8A56A',
  relations: '#6FCBB8',
  posture: '#B7B1B8',
  individual: '#E8A56A',
  environment: '#6FCBB8',
  event: '#C9B0E4',
};

/** @deprecated Use pillar colors instead */
const strongCategoryColors: Record<ThematicCategorySlug, string> = {
  [ThematicCategorySlug.BETTER_LIFE]: '#E8D414',
  [ThematicCategorySlug.PERSONAL_LIFE]: '#2464A0',
  [ThematicCategorySlug.PROFESSIONAL_LIFE]: '#B65A44',
  [ThematicCategorySlug.SELF_REFLECTION]: '#239692'
};

/** @deprecated Use pillar colors instead */
const lightCategoryColors: Record<ThematicCategorySlug, string> = {
  [ThematicCategorySlug.BETTER_LIFE]: '#F5F0B7',
  [ThematicCategorySlug.PERSONAL_LIFE]: '#B4CBE0',
  [ThematicCategorySlug.PROFESSIONAL_LIFE]: '#E8C7C0',
  [ThematicCategorySlug.SELF_REFLECTION]: '#B4DDDB'
};

/** @deprecated Use pillar colors instead */
const mediumCategoryColors: Record<ThematicCategorySlug, string> = {
  [ThematicCategorySlug.BETTER_LIFE]: '#F2E14D',
  [ThematicCategorySlug.PERSONAL_LIFE]: '#5491CB',
  [ThematicCategorySlug.PROFESSIONAL_LIFE]: '#E28873',
  [ThematicCategorySlug.SELF_REFLECTION]: '#53C1BD'
};


export {
  lightCategoryColors,
  mediumCategoryColors,
  strongCategoryColors,
  lightPillarColors,
  mediumPillarColors,
  strongPillarColors
};
